import { Button } from "@/components/ui";

type RepairIntakeFormActionsProps = {
  activeStep: number;
  isLastStep: boolean;
  onBack: () => void;
  onReset: () => void;
  onNext: () => void;
  onSubmit: () => void;
};

export function RepairIntakeFormActions({
  activeStep,
  isLastStep,
  onBack,
  onReset,
  onNext,
  onSubmit,
}: RepairIntakeFormActionsProps) {
  return (
    <div className="flex flex-col gap-3 border-gray-200 border-t pt-6 sm:flex-row sm:justify-between">
      <Button type="button" variant="outline" onClick={onBack} disabled={activeStep === 0}>
        Back
      </Button>
      <div className="flex flex-col-reverse gap-3 sm:flex-row">
        <Button type="button" variant="ghost" onClick={onReset}>
          Reset Form
        </Button>
        {isLastStep ? (
          <Button type="button" onClick={onSubmit}>
            Submit
          </Button>
        ) : (
          <Button type="button" onClick={onNext}>
            Next
          </Button>
        )}
      </div>
    </div>
  );
}
